import React, { useEffect } from 'react';

import { useAppDispatch } from '@src/core/hooks';
import { refreshCart } from '@src/features/cart';
import { TransactableSummaryContent, useTransactableSummary } from '@src/features/transactables/summary';

import { useCheckoutCouponManageability } from './hooks/useCheckoutCouponManageability';
import { CheckoutSidebarSkeleton } from './CheckoutSkeleton';

export const CheckoutSummarySidebar = () => {
  const dispatch = useAppDispatch();
  const { source, transactable, cart, isReady, canManageCartCoupon, isLoading } = useTransactableSummary();
  const canManageCoupon = useCheckoutCouponManageability(canManageCartCoupon);

  useEffect(() => {
    dispatch(refreshCart());
  }, [dispatch]);

  if (isLoading) {
    return <CheckoutSidebarSkeleton />;
  }

  if (!isReady) {
    return null;
  }

  return (
    <TransactableSummaryContent
      source={source}
      transactable={transactable}
      cart={cart}
      canManageCoupon={canManageCoupon}
    />
  );
};

export default CheckoutSummarySidebar;
